import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { UserGroupType } from 'tnx-admin-service/authorization/constants';
import { RoleService } from 'tnx-admin-service/authorization/role/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema, Operator } from 'tnx-shared';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
@Component({
    selector: 'role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.scss'],
    providers: [ComponentContextService],
})
export class RoleComponent extends DataListBase implements OnInit, AfterViewInit {

    @ViewChild('crudList', { static: false }) crudList: CrudListComponent;
    searchSchema: any = {};
    searchData: any = {};

    constructor(
        protected _injector: Injector,
        protected _roleService: RoleService,
        private _moduleService: ModuleService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._roleService;
        this.setting.objectName = 'vai trò';
        this.setting.popupSize.width = 1000;
        this.setting.popupSize.height = 800;
        this.setting.popupSize.maximize = true;

        this.setting.modelSchemas = [
            new ModelSchema({ field: 'moduleCode', name: 'Phân hệ', fullName: 'Phân hệ', description: 'Phân hệ' }),
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên vai trò', description: 'Tên vai trò' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã vai trò', description: 'Mã vai trò' }),
        ];

        this.setting.cols = [
            // new ColumnSchemaBase({
            //     field: 'moduleCode',
            //     baseService: this._moduleService,
            //     displayField: 'name',
            //     valueField: 'code',
            //     forceGetData: true,
            //     width: '150px'
            // }),
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'name' }),
        ];

        super.ngOnInit();
    }

    async modifyGridInfo(gridInfo: GridInfo) {
        gridInfo.filters.push(this.newFilter('type', Operator.equal, UserGroupType.Group));
    }
}

